import React from "react"
import styled from "styled-components"

import Adjective from "./Adjective"

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const ImageContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
`

const TextContainer = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  padding-left: 0.2rem;
  padding-right: 0.4rem;
`

type Props = {
  graphic: JSX.Element
  maintext: string
  subtext?: string
}

const OverviewSimple = ({graphic, maintext, subtext}: Props) => 
  <Container>
    <ImageContainer>{ graphic }</ImageContainer>
    <TextContainer>
      <span>{ maintext }</span>
      <Adjective>{ subtext }</Adjective>
    </TextContainer>
  </Container>

export default OverviewSimple